(function () {
  var SECTION_SEL = '[data-recently-viewed]';
  var GRID_SEL = '.oddit-section-recommended-products__grid';
  var CARD_SEL = '.oddit-section-recommended-products__card';
  var STORAGE_KEY = 'theme:recently-viewed-products';

  function readIds(root) {
    var ids = [];
    try {
      ids = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
    var exclude = parseInt(root.dataset.excludeId, 10);
    var limit = parseInt(root.dataset.productsCount, 10) || 8;
    return ids
      .filter(function (id, index) {
        return id && id !== exclude && ids.indexOf(id) === index;
      })
      .slice(0, limit);
  }

  function initCarousel(root) {
    var track = root.querySelector(GRID_SEL);
    var progress = root.querySelector('[data-recommended-progress]');
    var bar = root.querySelector('[data-recommended-progress-bar]');
    var navs = root.querySelectorAll('[data-recommended-nav]');
    if (!track) return;

    function sync() {
      var overflow = track.scrollWidth - track.clientWidth;
      var image = track.querySelector('.oddit-section-recommended-products__card-image-wrap');
      navs.forEach(function (nav) {
        var dir = Number(nav.dataset.recommendedNav);
        nav.hidden = overflow <= 1 || (dir < 0 ? track.scrollLeft <= 1 : track.scrollLeft >= overflow - 1);
        if (image) nav.style.top = image.offsetHeight / 2 + 'px';
      });

      if (!progress || !bar) return;
      if (overflow <= 1) {
        progress.hidden = true;
        return;
      }
      progress.hidden = false;
      var visible = track.clientWidth / track.scrollWidth;
      bar.style.width = visible * 100 + '%';
      bar.style.left = (track.scrollLeft / overflow) * (100 - visible * 100) + '%';
    }

    navs.forEach(function (nav) {
      nav.addEventListener('click', function () {
        var card = track.querySelector(CARD_SEL);
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        var step = card ? card.offsetWidth + gap : track.clientWidth;
        track.scrollBy({ left: step * Number(nav.dataset.recommendedNav), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', sync, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(sync).observe(track);
    sync();
  }

  function init(root) {
    if (!root || root.dataset.recentlyViewedBound) return;
    root.dataset.recentlyViewedBound = 'true';

    var grid = root.querySelector(GRID_SEL);
    if (!grid) return;

    var ids = readIds(root);
    if (!ids.length) {
      root.hidden = true;
      return;
    }

    var query = ids
      .map(function (id) {
        return 'id:' + id;
      })
      .join(' OR ');

    var url =
      (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') +
      'search?type=product&q=' + encodeURIComponent(query) +
      '&section_id=' + encodeURIComponent(root.id);

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector(GRID_SEL);
        var incoming = next ? next.querySelectorAll(CARD_SEL) : [];
        if (!incoming.length) {
          root.hidden = true;
          return;
        }

        grid.innerHTML = '';
        for (var i = 0; i < incoming.length; i++) {
          grid.appendChild(document.importNode(incoming[i], true));
        }

        root.hidden = false;
        initCarousel(root);
        grid.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      })
      .catch(function () {
        root.hidden = true;
      });
  }

  document.querySelectorAll(SECTION_SEL).forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector && e.target.querySelector(SECTION_SEL);
    if (s) init(s);
  });
})();
